module.exports = __webpack_public_path__ + "static/images/fccbd86df8fe271d3da9337c8fc745ed.png";